import { render, staticRenderFns } from "./ProductTagForm.vue?vue&type=template&id=356e4516&"
import script from "./ProductTagForm.vue?vue&type=script&lang=js&"
export * from "./ProductTagForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('356e4516')) {
      api.createRecord('356e4516', component.options)
    } else {
      api.reload('356e4516', component.options)
    }
    module.hot.accept("./ProductTagForm.vue?vue&type=template&id=356e4516&", function () {
      api.rerender('356e4516', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gift/orderMgt/modules/ProductTagForm.vue"
export default component.exports